import { isValidationError } from "@justhome/common";
import {
  ClientMode,
  PartnerCRMApplication,
  useGetPartnerProperty,
} from "@justhome/common/api/core";
import useLinks from "@lib/hooks/useLinks";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import TransferWithPropertyV2 from "@modules/application/components/TransferWithPropertyV2";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import useCreatePartnerLeadWithApplication from "@modules/application/hooks/useCreatePartnerLeadWithApplication";
import { useRouter } from "next/router";
import { FC } from "react";

interface PartnerWithPropertyProps {
  state: "pre" | "post";
  clientMode: ClientMode;
}

/**
 * @deprecated
 */
const PartnerWithPropertyAndContact: FC<PartnerWithPropertyProps> = ({
  state,
  clientMode,
}) => {
  const { dispatch } = useApplicationContext();
  const router = useRouter();
  const propertyId = router.query["property-id"] as string;
  const contactId = router.query["contact-id"] as string;
  const hasContact = !!contactId;
  const hasPropertyId = !!propertyId;
  const { partner } = usePartnerContext();
  const { data: property, error: propertyError } = useGetPartnerProperty(
    {
      pathParams: {
        partnerId: partner!.id!,
        propertyId,
      },
      queryParams: {
        clientMode,
      },
    },
    {
      enabled: hasPropertyId,
    },
  );
  const { getApplicationProcessLink, getMeetingLink } = useLinks();

  const {
    isError: isError,
    handleSubmit: onSubmit,
    isLoading: isLoading,
  } = useCreatePartnerLeadWithApplication({
    partnerId: partner!.id!,
    propertyId,
    clientMode,
    contactId,
    onSuccess(lead) {
      router.push(
        getApplicationProcessLink(
          lead.isOffersViewForbidden ? "forbidden" : "offers",
        ),
      );
    },
  });

  const {
    isError: isCTAError,
    handleSubmit: onCTA,
    isLoading: isCTALoading,
  } = useCreatePartnerLeadWithApplication({
    partnerId: partner!.id!,
    propertyId,
    clientMode,
    contactId,
    onSuccess() {
      if (state === "pre") {
        router.push(getMeetingLink() + "?meetingType=finanzcheck");
      } else {
        router.push(getMeetingLink());
      }
    },
  });

  const onSubmitWithoutContact = (values: PartnerCRMApplication) => {
    const partnerApplicationForm = {
      ...values,
      propertyId,
    };
    dispatch({
      type: "SET_PARTNER_APPLICATION_FORM",
      applicationForm: partnerApplicationForm,
    });
    router.push(
      getApplicationProcessLink(`${clientMode.toLowerCase()}-contact`),
    );
  };

  return (
    <TransferWithPropertyV2
      property={
        property ||
        (isValidationError(propertyError)
          ? propertyError.cause.payload?.property
          : undefined)
      }
      propertyError={propertyError}
      isError={isError}
      isLoading={isLoading}
      isSecondaryError={isCTAError}
      isSecondaryLoading={isCTALoading}
      onSubmit={hasContact ? onSubmit : onSubmitWithoutContact}
      showTerms={hasContact}
      offerState={state}
      onSecondaryCTA={onCTA}
      showBenefits={hasContact}
      clientMode={clientMode}
    />
  );
};

export default PartnerWithPropertyAndContact;
